window.addEventListener("load", function() {

  (function($){

    document.body.classList.add("loaded-doc");


    function externalLinks() {
      for(var c = document.getElementsByTagName("a"), a = 0;a < c.length;a++) {
        var b = c[a];
        b.getAttribute("href") && b.hostname !== location.hostname && (b.target = "_blank") && (b.classList.add("external-link"));
      }
    }
    externalLinks();

    if(document.querySelector(".m-h .mm-trigger")){
      document.querySelector(".m-h .mm-trigger").addEventListener("click", function(e){
        document.querySelector("body").classList.toggle("mobile-nav-active");
        document.querySelector("body").classList.remove("visible-search");
        e.preventDefault();
      });
    }
    if(document.querySelector(".m-h .ms-trigger")){
      document.querySelector(".m-h .ms-trigger").addEventListener("click", function(e){
        document.querySelector("body").classList.toggle("visible-search");
        document.querySelector("body").classList.remove("mobile-nav-active");
        e.preventDefault();
      });
    }

    $(document).on("click",".vce-trigger", function(){
      let vid = $(this).attr("data-vid");
      if($(".video-modal").length > 0) {
        $(".video-modal").remove();
        $("body").append('<div class="video-modal"><div class="vc-container"><a href="#" class="vc-close">&times;</a><iframe src="https://www.youtube.com/embed/'+vid+'?autoplay=1&rel=0" width="560" height="315" frameborder="0" allowfullscreen="allowfullscreen" allow="autoplay"></iframe></div></div>');
      }
      else {
        $("body").append('<div class="video-modal"><div class="vc-container"><a href="#" class="vc-close">&times;</a><iframe src="https://www.youtube.com/embed/'+vid+'?autoplay=1&rel=0" width="560" height="315" frameborder="0" allowfullscreen="allowfullscreen" allow="autoplay"></iframe></div></div>');
      }
      return false;
    });
    $(document).on("click",".video-modal .vc-close", function(){
      $(".video-modal").remove();
      return false;
    });

    $(document).on("click",".m-h .mh-mobile-menu .mhmn-nav li span",function(){
      $(this).parent().toggleClass("visible-submenu");
      return false;
    });

    $(document).on("click",".copy-with-columns .cwcr-trigger a",function(){
      $(this).parent().parent().toggleClass("active");
      let text = $(this).text();
      $(this).text(text == "Learn More" ? "Hide details" : "Learn More");
      return false;
    });

    if($(".acg-content").length > 0) {
      if($(".acg-content h2").length > 1) {
        String.prototype.cleanup = function() {
          return this.toLowerCase().replace(/[^a-zA-Z0-9]+/g, "-");
        }
        $(".jump-to-section").removeClass("hidden");
        let counter = 0;
        $(".acg-content h2, .acg-content h3").each(function(){
          let clabel = $(this).text().toLowerCase();
          let fclabel = $(this).text();
          clabel = clabel.replace(/^\w/, (c) => c.toUpperCase());
          let urllabel = $(this).text().cleanup();
          counter++;
          $(this).attr("id","heading-"+counter);
          $(".jump-to-section .jump-to-section-links .jsl").append("<p><a href='#heading-"+counter+"'>"+fclabel+"</a></p>");
        });
      }
    }

    $(document).on("click", ".jump-to-section a", function(){
      let correction = -124;
      let target = $(this).attr("href");
      $('html,body').animate({scrollTop: ($(target).offset().top+correction)}, 1000);
      return false;
    });

    $(document).on("click",".images-row a",function(){
      if($(this).hasClass("product-video-trigger")){
        $("body").append('<div class="product-video-modal"><div class="pvm-container"><a href="#">&times;</a><video controls autoplay><source src="'+$(this).attr("data-vid")+'"></video></div></div>');
      }
      else {
        let cimg = $(this).attr("data-image");
        $(".product-featured-image").css("background-image","url("+cimg+")");
        $(".images-row a").removeClass("current");
        $(this).addClass("current");
      }
      return false;
    });

    $(document).on("click",".paw-collapse .collapse-toggle",function(){
      if($(this).hasClass("active")) {
        $(this).parent().parent().find(".pcc-entry").removeClass("active");
        $(this).parent().find(".pt-nav").removeClass("active");
        $(this).parent().parent().removeClass("active");
        $(this).removeClass("active");
      }
      else {
        $(this).addClass("active");
        $(this).parent().parent().find(".pc-copy .pcc-entry:first").addClass("active");
        $(this).parent().find(".pt-nav:first").addClass("active");
        $(this).parent().parent().addClass("active");
      }
      return false;
    });

    $(document).on("click",".as-share .cl", function(){
      navigator.clipboard.writeText($(this).attr("href")).then(() => {
          $(".as-share").append("<span>Link copied to clipboard</span>")
          setTimeout(() => {
            $(".as-share span").remove();
          }, 3000);
        }).catch(err => {
          console.error("Failed to copy: ", err);
        }
      );
      return false;
    });

    if($(".copy-with-carousel .cwc-carousel").length > 0){
      $(".copy-with-carousel .cwc-carousel").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        responsive: [
          {
            breakpoint: 840,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    }
    if($(".slideshow-carousel").length > 0){
      $(".slideshow-carousel").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: true
      });
    }

    function getFaqScrollOffset() {
      var offset = 24;
      var stickyHeader = document.querySelector(".m-h");

      if(stickyHeader) {
        offset += stickyHeader.getBoundingClientRect().height || stickyHeader.offsetHeight || 0;
      }

      return offset;
    }

    function alignFaqCategory(targetElement) {
      if(!targetElement) {
        return;
      }

      window.requestAnimationFrame(function() {
        window.requestAnimationFrame(function() {
          var targetTop = targetElement.getBoundingClientRect().top + window.pageYOffset - getFaqScrollOffset();
          window.scrollTo({ top: Math.max(targetTop, 0), behavior: "auto" });
        });
      });
    }

    function openFaqCategory($targetCategory) {
      if($targetCategory.length === 0) {
        return false;
      }

      $(".faq-list .fl-category").removeClass("active");
      $targetCategory.addClass("active");
      return true;
    }

    function openFaqCategoryFromHash(shouldAlign) {
      if(window.location.hash.length < 2) {
        return false;
      }

      var targetId = decodeURIComponent(window.location.hash.substring(1));
      var targetElement = document.getElementById(targetId);

      if(!targetElement) {
        return false;
      }

      var $targetCategory = $(targetElement).closest(".fl-category");

      if(!openFaqCategory($targetCategory)) {
        return false;
      }

      if(shouldAlign !== false) {
        alignFaqCategory(targetElement);
      }

      return true;
    }

    if($(".faq-list").length > 0) {
      if(!openFaqCategoryFromHash()) {
        openFaqCategory($(".faq-list .fl-category:first"));
      }
    }
    $(document).on("click",".fl-category h2",function(){
      $(this).parent().toggleClass("active");
    });
    $(document).on("click",".faq-anchor-link",function(event){
      var targetHash = $(this).attr("href");

      event.preventDefault();
      event.stopPropagation();

      if(!targetHash) {
        return;
      }

      if(window.history && window.history.replaceState) {
        window.history.replaceState(null, "", targetHash);
      } else {
        window.location.hash = targetHash;
      }

      openFaqCategoryFromHash();
    });
    $(window).on("hashchange", function() {
      openFaqCategoryFromHash();
    });
    if($(".product-listing.pl-carousel").length > 0){
      $(".product-listing.pl-carousel").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        responsive: [
          {
            breakpoint: 840,
            settings: {
              slidesToShow: 2
            }
          }
        ]
      });
    }
    if($(".vce-carousel").length > 0){
      $(".vce-carousel").each(function(){
        $(this).slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          infinite: true,
          responsive: [
            {
              breakpoint: 540,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      });
    }

    if($(".vc-carousel").length > 0){
      $(".vc-carousel").slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '16px',
        cssEase: 'linear',
        swipeToSlide: true,
        arrows: true,
        dots: true,
        infinite: true,
        prevArrow: $(".video-carousel .vcc-controls .is-custom-prev"),
        nextArrow: $(".video-carousel .vcc-controls .is-custom-next"),
        appendDots: $(".video-carousel .vcc-controls .is-slick-dots-wrapper"),
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              centerMode: false
            }
          }
        ]
      });
    }


  })($);
});

document.addEventListener("click", function(e) {
  const btn = e.target.closest(".quant-selector .plus, .quant-selector .minus, .quantity-selector .plus, .quantity-selector .minus");
  if (!btn) return;

  const selector = btn.closest(".quant-selector") || btn.closest(".quantity-selector");
  const form = btn.closest("form");
  const qtyInput =
    (selector ? selector.querySelector("input[type='number']") : null) ||
    (form ? form.querySelector("#Quantity") : null);
  const qtyDisplay = selector ? selector.querySelector(".total-quant") : null;
  if (!qtyInput) return;

  e.preventDefault();

  let min = parseInt(qtyInput.getAttribute("min"), 10);
  if (Number.isNaN(min)) min = 1;

  let qty = parseInt(qtyInput.value, 10);
  if (Number.isNaN(qty) || qty < min) qty = min;

  if (btn.classList.contains("plus")) {
    qty += 1;
  } else if (qty > min) {
    qty -= 1;
  }

  qtyInput.value = String(qty);
  if (qtyDisplay) {
    qtyDisplay.textContent = String(qty);
  }

  const minusBtn = selector.querySelector(".minus");
  if (minusBtn) {
    minusBtn.classList.toggle("inactive", qty <= min);
  }

  if (selector.classList.contains("quantity-selector") && form && form.id === "sCartForm") {
    form.submit();
  }
});

document.addEventListener("change", function(e) {
  const target = e.target;

  if (target instanceof HTMLSelectElement && target.matches(".pm-variant-selector select[name='id']")) {
    const selected = target.selectedOptions && target.selectedOptions.length ? target.selectedOptions[0] : null;
    const variantId = selected ? selected.value : "";
    const sku = selected ? (selected.dataset.sku || "") : "";
    const price = selected ? (selected.dataset.price || "") : "";
    const comparePrice = selected ? (selected.dataset.comparePrice || "") : "";
    const hasComparePrice = selected ? (selected.dataset.hasComparePrice === "true") : false;
    const isLoyaltyCustomer = target.dataset.isLoyaltyCustomer === "true";
    const gridRow = target.closest(".grid-row");
    const skuNode = gridRow ? gridRow.querySelector(".mp-product-actions .sku") : document.querySelector(".mp-product-actions .sku");
    const priceNode = gridRow ? gridRow.querySelector(".mp-product-actions .product-list-price") : document.querySelector(".mp-product-actions .product-list-price");
    const documentsSection = document.querySelector(".product-documents");
    const documentsContent = documentsSection ? documentsSection.querySelector(".product-documents__content") : null;
    const documentTemplate = variantId ? document.querySelector(`template[data-variant-documents="${variantId}"]`) : null;

    if (skuNode) {
      skuNode.textContent = sku ? `SKU: ${sku}` : "SKU:";
    }

    if (priceNode && price) {
      const loyaltyPrice = isLoyaltyCustomer ? (selected.dataset.loyaltyPrice || "") : "";
      const loyaltyComparePrice = isLoyaltyCustomer ? (selected.dataset.loyaltyComparePrice || "") : "";

      if (loyaltyPrice) {
        priceNode.innerHTML = `<span class="price-amount loyalty-price">${loyaltyPrice}</span> <span class="compare-price"><s>${loyaltyComparePrice || price}</s></span>`;
      } else if (hasComparePrice && comparePrice) {
        priceNode.innerHTML = `<span class="price-amount">${selected.dataset.price}</span> <span class="compare-price"><s>${selected.dataset.comparePrice}</s></span>`;
      } else {
        priceNode.innerHTML = `<span class="price-amount">${price}</span>`;
      }
    }

    if (documentsSection && documentsContent) {
      const documentsMarkup = documentTemplate ? documentTemplate.innerHTML.trim() : "";
      documentsContent.innerHTML = documentsMarkup;
      documentsSection.hidden = !documentsMarkup;
    }
  }

  if (target instanceof HTMLSelectElement && target.matches(".product-quantity__select")) {
    const form = target.closest("form");
    const qtyInput = form ? form.querySelector("#Quantity") : null;
    if (qtyInput) {
      qtyInput.value = target.value;
    }
    return;
  }

  const input = target;
  if (!(input instanceof HTMLInputElement)) return;
  if (!input.matches(".quantity-selector input[type='number']")) return;

  const form = input.closest("form");
  if (form && form.id === "sCartForm") {
    form.submit();
  }
});
